import React, { useCallback } from 'react'
import {
  TypeStringAction,
  AnyActionType,
  IActionComponentProps,
} from '~core/forge.type'
import useDispatch from '~editor/hooks/useDispatch'
import { Box, Input, Button } from '@chakra-ui/react'

interface IProps extends IActionComponentProps {
  action: TypeStringAction
}

export const TypeStringActionComponent = ({
  action,
  actions,
  activeActionGesture,
}: IProps) => {
  const dispatch = useDispatch()

  const updateString = useCallback(
    (string: string) => {
      dispatch.nodes.updateActions({
        actionGestureType: activeActionGesture,
        actions: actions.map((_a: AnyActionType) => {
          const _action = { ..._a } as TypeStringAction

          if (action.id === _action.id) {
            _action.string = string
          }

          return _action
        }),
      })
    },
    [dispatch, activeActionGesture, actions],
  )

  return (
    <Box width="100%" display="flex" alignItems="center">
      <Input
        width="100%"
        height="32px"
        value={action.string}
        placeholder="Write your text here"
        onChange={(e) => {
          const string = e.target.value

          updateString(string)
        }}
      />
      <Button
        variant="warningGhost"
        fontSize="12px"
        onClick={() => {
          updateString('')
        }}
      >
        {'Clear'}
      </Button>
    </Box>
  )
}

export default TypeStringActionComponent
